import { styled } from "styled-components";

const TreatmentTag = styled.span<{ $variant: string }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
  vertical-align: baseline;
  font-size: 12px;

  background-color: ${({ theme, $variant }): string => {
    switch ($variant) {
      case "in_progress":
        return theme.palette.info[50];
      case "accepted":
        return theme.palette.warning[200];
      case "accepted_undefined":
        return theme.palette.error[50];
      case "untreated":
      default:
        return theme.palette.gray[200];
    }
  }};

  color: ${({ theme, $variant }): string => {
    switch ($variant) {
      case "in_progress":
        return theme.palette.info[700];
      case "accepted":
        return theme.palette.warning[700];
      case "accepted_undefined":
        return theme.palette.error[700];
      case "untreated":
      default:
        return theme.palette.gray[600];
    }
  }};
`;

export { TreatmentTag };
